import { render, staticRenderFns } from "./NewProductList.vue?vue&type=template&id=31071c0c"
import script from "./NewProductList.vue?vue&type=script&lang=js"
export * from "./NewProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports